export default "__VITE_ASSET__CLJrOhgA__"